import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useProperty, useSiteContext, useTranslation } from '@eti/providers';
import { useAuth } from '@eti/authentication';
import { routes } from '../../../constants/routesAndApisConstants';
import { initChatWidget } from './utils';

interface GenesysChatProps {
  extraInfo?: Record<string, string> | null;
}

const GenesysChat = ({ extraInfo }: GenesysChatProps) => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const { user } = useAuth();
  const { language, siteName } = useSiteContext();
  const location = useLocation();
  const siteLanguageCode = language?.code;
  const isRebookingPage = location.pathname.includes(routes.CHANGE_TRIP);

  useEffect(() => {
    const genesysWidgetsUrl = p('Chat.Widget.Configuration.GenesysWidgetsUrl');
    const webChatServiceUrl = p('Chat.Widget.Configuration.WebChatServiceUrl');
    const deploymentKey = p('Chat.Widget.Configuration.DeploymentKey');
    const orgGuid = p('Chat.Widget.Configuration.OrgGuid');
    const languageCodesWithoutNativeSupport = p('Chat.Widget.LanguageCodesWithoutNativeSupport');
    const shouldShowQuestions = p('Chat.Widget.QueueQuestions.Enabled');
    const texts = {
      answerNo: t('Chat.Widget.Dropdown.No.Text'),
      answerYes: t('Chat.Widget.Dropdown.Yes.Text'),
      optional: t('Chat.Widget.Placeholder.Optional'),
      orderNumber: t('Chat.Widget.OrderNumber.Label'),
      required: t('Chat.Widget.Placeholder.Required'),
      scheduleChangeQuestion: t('Chat.Widget.QuestionForScheduleChange.Label'),
      select: t('Chat.Widget.Dropdown.Select.Text'),
      unexpectedEventsQuestion: t('Chat.Widget.QuestionForUnexpectedEvents.Label'),
    };

    initChatWidget(
      webChatServiceUrl,
      genesysWidgetsUrl,
      deploymentKey,
      orgGuid,
      siteName,
      texts,
      siteLanguageCode,
      languageCodesWithoutNativeSupport,
      shouldShowQuestions,
      user?.email,
      user?.sessionOrderNumber,
      isRebookingPage,
      extraInfo,
    );
  }, [
    extraInfo,
    siteName,
    user?.email,
    user?.sessionOrderNumber,
    isRebookingPage,
    siteLanguageCode,
    p,
    t,
  ]);

  return null;
};

export default GenesysChat;
